import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

export const resetPasswordGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const token = route.queryParamMap.get('token')

  if (!token?.trim()) {
    return router.createUrlTree(['/signin']);
  }

  return authService.verifyResetToken(token).pipe(
    map((valid) => valid ? true : router.createUrlTree(['/signin'])),
    catchError(() => of(router.createUrlTree(['/signin'])))
  );
};
